import { ActionReducerMap } from '@ngrx/store';

// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface State {}

export const ROOT_REDUCERS: ActionReducerMap<State> = {};
